import { UpdateFreespinsBetbarCommand } from "slotworks/commands/betbar/update-freespins-betbar-command";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";

export default class FreespinIdle extends State {

    public static WAIT: number = 0;
    public static WAIT_ONLY_WHEN_NO_WINS: boolean = false;

    private waitTimer: number;

    public onEnter() {

        UpdateFreespinsBetbarCommand();

        if (this.shouldPlayWaitTimer()) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), FreespinIdle.WAIT);
        } else {
            this.complete();
        }
    }

    public onSkip() {
        Timer.clearTimeout(this.waitTimer);

        this.skip();
    }

    public onExit() {
        Components.matrix.resetSymbols();

        super.onExit();
    }

    private shouldPlayWaitTimer() {
        const isWaitTimeZero = FreespinIdle.WAIT <= 0;

        if (isWaitTimeZero) {
            return false;
        }

        if (!FreespinIdle.WAIT_ONLY_WHEN_NO_WINS) {
            return true;
        }

        const isWin = gameState.currentRecordHasSymbolWinResults() || gameState.currentRecordHasFreespinWinResults();
        const hasNoWins = !isWin;

        return hasNoWins;
    }
}
